module.exports = "<ota-dialog\n  [fullscreen]=\"false\"\n  [disbledClose]=\"true\"\n  [closeBottom]=\"true\"\n  class=\"dialog-taxes-fees\"\n>\n  <div class=\"dialog-title\">\n    {{ 'cart-taxes-fees' | translate }}\n  </div>\n  <div class=\"dialog-body\">\n    {{ 'cart-taxes-fees-description' | translate }}\n  </div>\n</ota-dialog>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cart/dialog-taxes-fees/dialog-taxes-fees.component.html
// module id = 1022
// module chunks = 22